<template>
  <div class="p-4">
    <h1>App Settings</h1>
    <hr />
    <h2>CORE</h2>
    <p>
      <strong>Build DateTime:</strong> {{ dateFormat(processEnv.VUE_APP_BUILD_TIME / 1000, true) }}
    </p>
    <p><strong>Version:</strong> {{ processEnv.VUE_APP_PACKAGE_VERSION }}</p>
    <p><strong>API URL:</strong> {{ processEnv.VUE_APP_API_URL }}</p>
    <p><strong>Base URL:</strong> {{ processEnv.VUE_APP_BASE_URL }}</p>
    <p><strong>Websocket URL:</strong> {{ processEnv.VUE_APP_WEBSOCKET }}</p>
    <hr />

    <h2>ANALYTICS</h2>
    <p><strong>Fullstory ID:</strong> {{ processEnv.VUE_APP_FULLSTORY_ID }}</p>
    <p><strong>GTM ID:</strong> {{ processEnv.VUE_APP_GTM_ID }}</p>
    <hr />

    <h2>Changelog</h2>
    <router-link :to="{ name: 'changelog' }">See changelog</router-link>
  </div>
</template>

<script>
import { dateFormat } from "leatherman-js/utils/formatters/time";

export default {
  name: "AppInfoPage",
  setup() {
    const processEnv = process.env;

    return {
      processEnv,
      dateFormat,
    };
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-weight: bold;
  margin-bottom: 1rem;
}
</style>
